import './index.css'
/* 
暂无访问权限 页面 

import NoPermissionTem from '@/components/antd-comp/NoPermission'
{xxx && <NoPermissionTem></NoPermissionTem>}

*/
const NoPermissionTem = (props: any) => {
  return (
    <div className="NoPermissionIcon_case flexRow" {...props}>
      <div className="NoPermissionIcon_content flexRow">
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M34 54C34 49.5817 37.5817 46 42 46H95C99.4183 46 103 49.5817 103 54V92C103 96.4183 99.4183 100 95 100H42C37.5817 100 34 96.4183 34 92V54Z"
            fill="url(#paint0_linear_6571_131695)"
          />
          <path
            d="M52 46V37C52 27.6112 59.6112 20 69 20V20C78.3888 20 86 27.6112 86 37V46"
            stroke="url(#paint1_linear_6571_131695)"
            strokeWidth="8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34 52C34 48.6863 36.6863 46 40 46H92C95.3137 46 98 48.6863 98 52V92C98 95.3137 95.3137 98 92 98H40C36.6863 98 34 95.3137 34 92V52Z"
            fill="white"
          />
          <path
            d="M34 52C34 48.6863 36.6863 46 40 46H92C95.3137 46 98 48.6863 98 52V92C98 95.3137 95.3137 98 92 98H40C36.6863 98 34 95.3137 34 92V52Z"
            fill="url(#paint2_linear_6571_131695)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70 68.0004C71.2144 67.0882 72 65.6358 72 64C72 61.2386 69.7614 59 67 59C64.2386 59 62 61.2386 62 64C62 65.6358 62.7856 67.0882 64 68.0004V76C64 77.6569 65.3431 79 67 79C68.6569 79 70 77.6569 70 76V68.0004Z"
            fill="#D9D9D9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70 68.0004C71.2144 67.0882 72 65.6358 72 64C72 61.2386 69.7614 59 67 59C64.2386 59 62 61.2386 62 64C62 65.6358 62.7856 67.0882 64 68.0004V76C64 77.6569 65.3431 79 67 79C68.6569 79 70 77.6569 70 76V68.0004Z"
            fill="url(#paint3_linear_6571_131695)"
          />
          <path
            d="M31.8397 70.2404L17.1823 92.2265C14.9672 95.5493 17.3491 100 21.3426 100H50.6574C54.6509 100 57.0328 95.5493 54.8177 92.2265L40.1603 70.2404C38.1811 67.2717 33.8189 67.2717 31.8397 70.2404Z"
            fill="url(#paint4_linear_6571_131695)"
          />
          <path
            d="M31.8397 70.2404L17.1823 92.2265C14.9672 95.5493 17.3491 100 21.3426 100H50.6574C54.6509 100 57.0328 95.5493 54.8177 92.2265L40.1603 70.2404C38.1811 67.2717 33.8189 67.2717 31.8397 70.2404Z"
            fill="url(#paint5_linear_6571_131695)"
          />
          <rect x="34" y="77" width="4" height="12" rx="2" fill="white" />
          <rect x="34" y="91" width="4" height="4" rx="2" fill="white" />
          <defs>
            <linearGradient
              id="paint0_linear_6571_131695"
              x1="68.5"
              y1="46"
              x2="68.5"
              y2="154.482"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C0C5FF" />
              <stop offset="1" stopColor="#3241FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_6571_131695"
              x1="68.7792"
              y1="10.0333"
              x2="83.7468"
              y2="46.2015"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#EBECFF" />
              <stop offset="1" stopColor="#C0C4FF" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_6571_131695"
              x1="66"
              y1="46"
              x2="66"
              y2="98"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#EBECFF" />
              <stop offset="1" stopColor="#C0C4FF" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_6571_131695"
              x1="66.6585"
              y1="18.0232"
              x2="54.3862"
              y2="79.6887"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C0C5FF" />
              <stop offset="1" stopColor="#3241FF" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_6571_131695"
              x1="36"
              y1="64"
              x2="36"
              y2="100"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#EBECFF" />
              <stop offset="1" stopColor="#C0C4FF" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_6571_131695"
              x1="38.634"
              y1="7.8734"
              x2="32.0539"
              y2="99.7173"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C0C5FF" />
              <stop offset="1" stopColor="#3241FF" />
            </linearGradient>
          </defs>
        </svg>
        <span className="NoPermissionIcon_title">暂无访问权限</span>
        <span className="NoPermissionIcon_text">请联系超级管理员处理</span>
      </div>
    </div>
  )
}

export default NoPermissionTem
